<template>
  <div class="bots-wrapper">
    <div v-if="bots.length > 0" class="tool-row">
      <div class="bot-item" v-for="(bot, key) in bots" :key="key">
        <ToolsCard
          image="darkside.svg"
          :title="bot.toolName"
          :price="bot.toolPrice"
          :desc="bot.toolDesc"
        ></ToolsCard>
      </div>
    </div>
    <div class="no-bots" v-else>
      <h1>No Bots yet</h1>
    </div>
    <div class="tool-action">
      <ButtonOutlined text="Load More"></ButtonOutlined>
    </div>
  </div>
</template>

<script>
import ToolsCard from "../../../../components/user/tool/ToolsCard";
import ButtonOutlined from "../../../../components/common/ButtonOutlined";
import { getBots } from "../../../../api/misc";
export default {
  components: {
    ToolsCard,
    ButtonOutlined,
  },
  data() {
    return {
      bots: [],
    };
  },

  async mounted() {
    const bots = await getBots();
    this.bots = bots.data.tools;
  },
};
</script>

<style scoped>
.bots-wrapper {
  height: 100%;
}
.no-bots {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tool-row {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.bot-item {
  max-width: 30%;
  width: 30%;
  margin-bottom: 24px;
  display: flex;
  margin-right: 1.5%;
  margin-left: 1.5%;
}
.tool-action {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  display: none;
}
@media only screen and (max-width: 785px) {
  .bot-item {
    flex: 47% !important;
    max-width: 47% !important;
    width: 47% !important;
    margin-bottom: 32px;
  }
  .tool-row {
    flex-wrap: wrap !important;
    margin-bottom: 0px !important;
  }
}

@media only screen and (max-width: 525px) {
  .bot-item {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    margin-bottom: 32px;
  }
}
</style>
